import Item from './Item';
import Purchase from './Purchase';
import * as AT from '../../components/container/attributes';

export default class PurchaseItem extends Item {
  constructor({
    id,
    number,
    designation,
    description = undefined,
    parent = undefined,
    active = true,
    option = undefined,
    itemType = undefined,
    titleLevel = undefined,
    resource = undefined,
    adminType = undefined,
    quantity = undefined,
    unit = undefined,
    discount = undefined,
    taxCode = undefined,
    comment = undefined,
    calculated = false,
    purchase = undefined,
    grossPrice = undefined,
    purchasePrice = undefined,
    purchaseAmount = undefined,
    pricePrecision = undefined,
  }) {
    super(
      id,
      number,
      designation,
      description,
      parent,
      active,
      option,
      itemType,
      titleLevel,
      resource,
      adminType,
      quantity,
      unit,
      discount,
      taxCode,
      comment,
      calculated,
    );
    this.purchase = purchase ? new Purchase(purchase) : null;
    this.grossPrice = grossPrice;
    this.purchasePrice = purchasePrice;
    this.purchaseAmount = purchaseAmount;
    this.pricePrecision = pricePrecision;
  }

  static get fkName() {
    return 'purchase_item_id';
  }
  static get apiRoute() {
    return 'purchase_item';
  }
  static get detailPageRoute() {
    return 'purchaseItems';
  }
  static get listPageRoute() {
    return 'purchaseItems';
  }
  get fkName() {
    return PurchaseItem.fkName;
  }
  get apiRoute() {
    return PurchaseItem.apiRoute;
  }
  get listPageRoute() {
    return PurchaseItem.listPageRoute;
  }
  get detailPageRoute() {
    return PurchaseItem.detailPageRoute;
  }

  static get joinAttrsKey() {
    return [
      'number',
      'designation',
      'unit',
      'adminType',
      'quantity',
      'grossPrice',
      'discount',
      'purchasePrice',
      'purchaseAmount',
      'taxCode',
      'comment',
      'itemType',
      'titleLevel',
      'resource',
      'description',
      'purchase',
    ];
  }

  static get listDisplayAttrs() {
    return this.getAttributes(
      [
        'itemType',
        'number',
        'designation',
        'unit',
        'adminType',
        'quantity',
        'grossPrice',
        'discount',
        'purchasePrice',
        'purchaseAmount',
        'taxCode',
        'comment',
        'option',
      ],
      [
        'titleLevel',
        'resource',
        'description',
        'purchase',
        'calculated',
        'sortOrder',
        'pricePrecision',
      ],
    );
  }

  static get allAttributes() {
    const baseAttributes = Item.allAttributes;
    const unitAttr = baseAttributes.find((attr) => attr.name === 'unit');
    unitAttr.joinPath = ['unit!fk_purchase_item_unit_id_unit'];
    const taxCodeAttr = baseAttributes.find((attr) => attr.name === 'taxCode');
    taxCodeAttr.joinPath = ['tax_code!fk_purchase_item_tax_code_id_tax_code'];
    taxCodeAttr.filters = {
      journal_type: 'eq.PURCHASE',
    };
    const resourceAttr = baseAttributes.find(
      (attr) => attr.name === 'resource',
    );
    resourceAttr.joinPath = ['resource!fk_purchase_item_resource_id_resource'];

    const customAttributes = [
      new AT.FkPurchaseAttribute({
        name: 'purchase',
        joinPath: ['purchase!fk_purchase_item_purchase_id_purchase'],
        tableProperties: {
          header: 'hit-app.common.purchase',
        },
      }),
      new AT.DecimalAttribute({
        name: 'grossPrice',
        decimalPrecisionForcedByColumn: 'pricePrecision',
        column: 'gross_price',
        default: 0.0,
        tableProperties: {
          header: 'hit-app.common.gross-price-short',
          maxWidth: '0.5fr',
        },
      }),
      new AT.DecimalAttribute({
        name: 'purchasePrice',
        decimalPrecisionForcedByColumn: 'pricePrecision',
        column: 'purchase_price',
        default: 0.0,
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.purchase-price',
          maxWidth: '0.5fr',
          readOnly: true,
        },
      }),
      new AT.DecimalAttribute({
        name: 'purchaseAmount',
        decimalPrecision: 2,
        column: 'purchase_amount',
        default: 0.0,
        readOnly: true,
        tableProperties: {
          header: 'hit-app.common.purchase-amount',
          maxWidth: '0.65fr',
          readOnly: true,
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
      new AT.IntegerAttribute({
        name: 'pricePrecision',
        column: 'price_precision',
      }),
    ];
    return baseAttributes.concat(customAttributes);
  }
}
